import * as logLevel from "loglevel";

// generate unique id (without an external library!!! yay.)
export const uuid = () => {
  return "" + crypto.randomUUID();
};
export const logger = logLevel;

if (typeof window !== "undefined") {
  // Expose the app logger for browser automation only after dev mode is enabled.
  Object.defineProperty(
    window as typeof window & { logger?: typeof logger },
    "logger",
    {
      configurable: true,
      get: () => (window.cnc?.settings?.get("dev") ? logger : undefined)
    }
  );
}
